import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showTitle'
})
export class ShowTitlePipe implements PipeTransform {

  transform(value: any[] | undefined): boolean {
    if(value){
      const data = value.find(x => x.text === 'Galerias')?.selected;
      if((data && data === 'showTitle') || !data){
        return true;
      }else{
        return false;
      }
    }
  }

}
